(ns practitest.frontend.testset2.index
  (:require [practitest.frontend.common-entities :refer [batch-navigate!]]
            [practitest.frontend.common-entities.index :refer [index-content-panel] :as common-index]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.common.i18n :as i18n :refer [format-translation
                                                              get-translation]]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.common.permissions :as permissions]
            [practitest.frontend.components.confirmation :as confirmation]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.navigation :as navigation]
            [practitest.frontend.components.overlay2 :as overlay2]
            [practitest.frontend.components2.grid :as grid2]
            [practitest.frontend.events :as events]
            [practitest.frontend.folders :as folders]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.testset2.events :as testset-events :refer [testsets-instances-state-key]]
            [practitest.frontend.testset2.instance-view-toggle :refer [instance-view-toggle-button]]
            [practitest.frontend.testset2.subs :as testset-subs]
            [practitest.frontend.testset2.testset-grid :as testset-grid]
            [practitest.frontend.testset2.testsets-instances-grid :as testsets-instances-grid]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

(def current-entity :testset)
(def include-descending? true)
(def state-key testset-events/testset-index-state-key)


(def main-controller
  {:start    (fn []
               (re-frame/dispatch [::events/set-current-entity-type current-entity])
               (re-frame/dispatch [::testset-events/initialize-instance-view-mode])
               (re-frame/dispatch [::folders/fetch-folders current-entity include-descending?]))
   :identity :parameters})

(defn instances-toolbar [form-props grid-props]
  (let [local-state (reagent/atom {})]
    (fn [{:keys [xbot?
                 edit-permissions?
                 entity-id] :as form-props}
         {:keys [local-state-updating
                 show-edit-columns?] :as grid-props}]
      (let [;; Set of IDs
            selection @(re-frame/subscribe [::grid.subs/selection [current-entity testsets-instances-state-key]])
            instances @(re-frame/subscribe [::grid.subs/data [current-entity testsets-instances-state-key]])]
        [:div.instances-toolbar
         [:div {:style {:margin-right "auto"}}
          [instance-view-toggle-button]]
         ;; More actions
         (let [show? (:show-toolbar-menu? @local-state)
               hide! (fn []
                       (swap! local-state assoc :show-toolbar-menu? false))
               toggle! (fn []
                         (swap! local-state update :show-toolbar-menu? not))

               disabled? (not edit-permissions?)]
           [overlay2/floating-ui-overlay
            {:placement        "bottom-end"
             :strategy         "absolute"
             :offset           5
             :show?            show?
             :on-request-close hide!}

            ;; Target
            [:button.more-button
             (-> {:class (dom/classes-pairs-v :disabled disabled?)
                  :disabled disabled?
                  :on-click (fn [e]
                              (when-not disabled?
                                (toggle!)))}
                 (dom/add-test-id "instances-grid-more-btn"))
             [icons/mux-three-dots]]

            ;; Menus
            [:div.menu-popup
             {:style {:width     "max-content"
                      :min-width "233px"}}

             ;; Edit columns menu item
             [grid2/edit-columns-menu-item grid-props]

             (let [disabled? (and (not (permissions/has-permission? "runs_admin")) (grid.subs/empty-selection? selection))

                   show-confirmation? (reagent/cursor local-state [:batch-delete-confirmation?])
                   hide-confirmation! #(reset! show-confirmation? false)
                   show-confirmation! #(reset! show-confirmation? true)]
               [:<>
                (let [n (count selection)
                      ;; TODO: reuse confirmation dialog from row-level deletion somehow ?
                      single-instance? (= n 1)
                      row (when single-instance?
                            (first (filter #(= (:id %) (first selection)) instances)))]
                  [confirmation/confirm
                   {:show?     show-confirmation?
                    :title     (if single-instance?
                                 (get-translation "instance.delete-confirmation.title"
                                                  "Delete Instance?")
                                 (get-translation "instance.batch-delete-confirmation.title"
                                                  "Delete Instances?"))
                    :body      (if single-instance?
                                 (let [id (first selection)
                                       row (first (filter #(= (:id %) id) instances))]
                                   (format-translation
                                    (get-translation "instance.delete-confirmation.body"
                                                     "\"%{object-name}\" will be deleted permanently.")
                                    :object-name (fu/truncate-text (:title row) 30)))

                                 ;; Multiple rows deletion
                                 (format-translation
                                  (get-translation "instance.batch-delete-confirmation.body"
                                                   "%{count} instances will be deleted permanently")
                                  :count n))

                    :yes-label "Delete"
                    :on-yes    (fn [e]
                                 (if single-instance?
                                   (re-frame/dispatch [::testset-events/delete-instance (:id row) true])
                                   (re-frame/dispatch [::testset-events/batch-delete-instances selection true]))

                                 ;; TODO: hide after response ?
                                 (hide-confirmation!))

                    :no-label  "Cancel"
                    :on-no     hide-confirmation!}])

                [navigation/menu-item-element {:text      (get-translation "testset.button.delete" "Delete")
                                               :test-id   "instances-grid-batch-delete-item"
                                               :disabled? disabled?
                                               :icon      icons/mux-trash
                                               :on-click  (fn [e]
                                                            (dom/prevent-default e)
                                                            (mixpanel/track "Batch delete instances")
                                                            (show-confirmation!))}]])
                                                            ;; TODO: new endpoint ?
                                                            ;(batch-navigate! batch-delete-uri selection)


             (let [disabled? (grid.subs/empty-selection? selection)]
               [navigation/menu-item-element {:text      (get-translation "testset.instances.set-parameters" "Set Parameters")
                                              :test-id   "instances-grid-set-parameters-item"
                                              :icon      icons/mux-parameters-set
                                              :disabled? disabled?
                                              :on-click  (let [batch-steps-params-uri (broutes/get-url-view "steps_params#index")]
                                                           (fn [e]
                                                             (dom/prevent-default e)
                                                             (mixpanel/track "Set Parameters")
                                                             (batch-navigate! batch-steps-params-uri selection)))}])]])]))))


(defn entities-grid [grid-state]
  (let [instance-view-mode? @(re-frame/subscribe [::testset-subs/instance-view-mode?])]
    (if-not instance-view-mode?
      [testset-grid/grid grid-state]
      ;; Create minimal form-props with edit? and edit-permissions? flags
      (let [form-props {:edit? true
                        :edit-permissions? (permissions/has-permission? "instances_editor")
                        :expanded? false}]
        [testsets-instances-grid/testsets-instances-grid form-props grid-state :instances-toolbar instances-toolbar]))))

(defn index []
  (let [instance-view-mode? @(re-frame/subscribe [::testset-subs/instance-view-mode?])
        current-state-key (if instance-view-mode?
                             testsets-instances-state-key
                             state-key)]
    
      [index-content-panel {:module "TestSet" :current-entity current-entity :state-key current-state-key :entities-grid entities-grid}]))


(defn ^:export init [options]
  (let [{:keys [translation]} (-> options (js->clj :keywordize-keys true))]
    (i18n/append-translation! @(re-frame/subscribe [::subs/current-locale]) translation)))


